/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import Analytics, { AnalyticsInstance } from 'analytics';

import { BASE_DATA_STORAGE_KEY } from './constants';
import { eventTypes, KUxAnalyticsOptions, KUxBaseEventData } from './interfaces/';

export class KUxAnalytics {
  private an: AnalyticsInstance;
  private static instance: KUxAnalytics;
  private autoSequenceId? = 0;

  public get sequenceId(): string {
    if (this.autoSequenceId === 10000) {
      this.autoSequenceId = 0;
    }
    // @ts-expect-error TODO Fix
    this.autoSequenceId = this.autoSequenceId + 1;
    return this.autoSequenceId.toString();
  }

  private constructor(opts: KUxAnalyticsOptions, baseData: KUxBaseEventData) {
    this.an = Analytics(opts as any);
    opts.plugins.forEach((plugin) => {
      (plugin.config as any).appData = {
        name: opts.app,
        version: opts.version,
      };
    });
    this.an.storage.setItem(BASE_DATA_STORAGE_KEY, baseData);
  }

  public static configure(opts: KUxAnalyticsOptions, baseData: KUxBaseEventData) {
    if (!KUxAnalytics.instance) {
      KUxAnalytics.instance = new KUxAnalytics(opts, baseData);
    } else {
      this.getInstance().updateBaseData(baseData);
    }
  }

  public static getInstance(): KUxAnalytics {
    if (!KUxAnalytics.instance) {
      console.log('KUxAnalytics not configured to configure call configure method');
    }
    return KUxAnalytics.instance;
  }

  public async send(event: eventTypes, callback?: (...params: any[]) => any, errCallback?: Function) {
    try {
      await this.an.track(
        event.constructor.name || '',
        { event, sequenceId: this.sequenceId },
        { errCallback },
        callback,
      );
    } catch (e) {
      console.log(e, 'Analytics-error');
      throw e;
    }
  }

  public updateBaseData(data: Partial<KUxBaseEventData>) {
    const updated = {
      ...this.an.storage.getItem(BASE_DATA_STORAGE_KEY),
      ...data,
    };
    this.an.storage.removeItem(BASE_DATA_STORAGE_KEY);
    this.an.storage.setItem(BASE_DATA_STORAGE_KEY, updated);
  }
}
